import { useApiClient } from '../hooks/useApiClient'

export function useMatchOptionsForBol(
  params: { bol_id: string },
  options?: {
    enabled?: boolean
  }
) {
  const $api = useApiClient()

  return $api.useQuery(
    'post',
    '/supplier_rec/match/options_for_bol',
    {
      params: {
        query: params,
      },
    },
    options
  )
}
